import axios, { AxiosPromise, AxiosRequestConfig } from 'axios';
import { ROOT_PATH } from '@/origin';
import { md5sign } from './md5sign';
import { loadingEmitter } from '@/utils/loadingEmitter';
import { setupInterceptors } from './interceptors';
import { requestDedupe } from './requestDedupe';

type CodeType = string | number;
export interface Data { [key: string]: any };
export interface ResponseData<U = Data> { data: U, code: CodeType, msg: string };

// Axios 实例
const service = axios.create({ timeout: 60000 });
setupInterceptors(service);

export default function send<T = any>(config: AxiosRequestConfig & { options?: { loading?: boolean; externalAuth?: Record<string, any> } }): AxiosPromise<T> {
  const { data = null, url = '', method = 'GET', params, options, headers = {}, responseType, onUploadProgress, onDownloadProgress, signal } = config;
  const { loading = true, externalAuth } = options || {};

  const requestUrl = url.startsWith('http') ? url : `${ROOT_PATH}${url}`;
  const requestParams = md5sign(params || {}, externalAuth);

  let requestKey: string | null = null;
  try {
    const isFormData = data instanceof FormData;
    if (!isFormData) {
      requestKey = `${requestUrl}|${method}|${JSON.stringify(requestParams)}|${JSON.stringify(data)}`;
    }
  } catch (_) {
    requestKey = null;
  }

  if (requestKey && requestDedupe.has(requestKey)) return requestDedupe.get(requestKey) as AxiosPromise<T>;

  requestDedupe.cleanup();

  if (loading) loadingEmitter.show();

  const request = service({ url: requestUrl, method, data, headers, params: requestParams, responseType, onUploadProgress, onDownloadProgress, signal })
    .finally(() => {
      if (requestKey) requestDedupe.delete(requestKey);
      if (loading) loadingEmitter.hide();
    });

  if (requestKey) requestDedupe.set(requestKey, request);
  return request as AxiosPromise<T>;
}